import { ReactComponent as MiddleSvg } from '../../../images/manifold/middle.paths.svg';

type Props = {
  xTransform: number;
  yTransform: number;
};
export const MiddlePaths = ({ xTransform, yTransform }: Props) => {
  return (
    <g transform={`matrix(0, -1, 1, 0, ${xTransform}, ${yTransform})`}>
      <MiddleSvg />
    </g>
  );
};
